<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-start flex-wrap">
      <div class="d-flex" v-for="menu in menus" :key="menu.routeName">
        <div class="card m-2 shadow">
          <router-link :to="{name:menu.routeName}">
            <img class="mt-3 mx-5" :src="'/img/icon/menu-' + menu.icon + '.png'" :alt="menu.displayName">
            <div class="card-body text-center position-relative">
              <span class="card-text text-primary">{{ menu.displayName }}</span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopMenu",
  props: {
    menus: {
      type: Array,
      required: true,
    }
  },
}
</script>

<style scoped>
.card-text::after{
  position: absolute;
  content: '';
  top: 50%;
  right: 5px;
  width: 10px;
  height: 10px;
  border: 8px solid transparent;
  border-left: 8px solid;
  transform: translateY(-50%);
}
</style>
